import '.ff{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.fg{padding-left:1.5rem;}.ssr-plugin'
import '.fh{margin:1rem 0;}.ssr-plugin'
import '.fi{color:var(--gray-700);}.ssr-plugin'
import '.fj{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="ff fg fh fi fj"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
